import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();

export const addBusiness = async (data) => {
  try {
    const response = await api.create(`/developer-accounts/${data?.merchandId}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBusinessByMarchandId = async (merchandId) => {
  try {
    const response = await api.get(`/developer-accounts/merchant/${merchandId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyByMarchandId = async (merchandId) => {
  try {
    const response = await api.get(`/merchants/${merchandId}/companies`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllDevelopers = async () => {
  try {
    const response = await api.get(`/developer-accounts/all`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateDeveloper = async (accountId, data) => {
  try {
    const response = await api.put(`/developer-accounts/${accountId}`, data);
    console.log('update', response)
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteDeveloper = async (id) => {
  try {
    const response = await api.delete(`/developer-accounts/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyByCompanyId = async (companyId) => {
  try {
    const response = await api.get(`/developer-accounts/company/${companyId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const makeProdDeveloper = async (developerId) => {
  try {
    const response = await api.put(`/developer-accounts/${developerId}/switch-to-production`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addSector = async (name) => {
  try {
    const response = await api.create(`/sector/create`, { name });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSector = async () => {
  try {
    const response = await api.get(`/sector/all`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTurnOverByBusinessId = async (merchandId, year) => {
  try {
    const response = await api.get(`/stats/accounts/merchants/${merchandId}/monthly-revenue?year=${year}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMetricsByMerchandId = async (merchandId) => {
  try {
    const response = await api.get(`/stats/accounts/merchant/${merchandId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailCountryPerMerchantCC = async (merchandId, countryCode) => {
  try {
    const response = await api.get(`/stats/accounts/merchant/${merchandId}/country/${countryCode}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMetricsTransByMerchandId = async (merchandId) => {
  try {
    const response = await api.get(`/stats/accounts/${merchandId}/country-performance`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailCountry = async (merchandId, countryCode) => {
  try {
    const response = await api.get(`/stats/accounts/merchant/${merchandId}/country/${countryCode}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMetricsByBusIdPercountryCode = async (busId, cc) => {
  try {
    const response = await api.get(`/developer-accounts/${busId}/country-balance/${cc}`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getAnnualTransfertByBusinessId = async (busId, year) => {
  try {
    const response = await api.get(`/developer-accounts/${busId}/transfers/${year}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTransStatByBusId = async (busId, month, year) => {
  try {
    const response = await api.get(`/developer-accounts/${busId}/transactionStats?month=${month}&year=${year}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMetricsByBusIdPerOperator = async (merchandId) => {
  try {
    const response = await api.get(`/stats/accounts/merchant/${merchandId}/payment-category`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getPaymentMethodeBusiness = async (busId) => {
  try {
    const response = await api.get(`/developer-accounts/${busId}/country-balances/active`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateEnvironment = async (request) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/developer-accounts/environment/${request.businessId}`, null,
      {
        params: {
          mode: request.mode
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateBusinessDocument = async (values) => {
  const formData = new FormData();
  formData.append("file", values.file);

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/developer-accounts/business-registry/${values.businessId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${values.token}`,
      }
    }
  );
  return response;
}
export const updateDeveloperReversement = async ({ developerAccountId, enable, token }) => {
  return api.post(
    `/admin/dashboard/toggle-payout`,
    {
      developerAccountId,
      enable,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

